<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <div class="footer-body">
    <div class="columns">
      <div class="column is-4 subscribe-column">
        <div class="subscribe-tile">
          Subscribe to our newsletter<br />
          <div class="field">
            <div class="control">
              <input
                class="input is-primary subscribe-input"
                type="email"
                placeholder="Type your email"
              />
            </div>
          </div>
          <div class="subscribe-button-wrapper">
            <button class="button is-light is-small">
              Subscribe
            </button>
          </div>
        </div>
      </div>
      <div class="column is-4 subscribe-column">
        <div class="is-flex">
          <a
            href="https://www.facebook.com/bz.prf.uk"
            target="_blank"
            :title="$t('Go to our facebook page')"
          >
            <div class="column is-narrow social-icon">
              <facebook-icon width="64px" height="64px"></facebook-icon>
            </div>
          </a>
          <a
            href="https://www.instagram.com/explore/locations/250577276/botanicka-zahrada-prirodovedecke-fakulty-univerzity-karlovy"
            target="_blank"
            :title="$t('Go to our instagram page')"
          >
            <div class="column is-narrow social-icon">
              <instagram-icon width="64px" height="64px"></instagram-icon>
            </div>
          </a>
        </div>
      </div>
      <div class="column is-4 subscribe-column">
        <ul>
          <li>
            <router-link :to="{ name: ROUTE_NAMES.CONTACTS }" class="link">
              {{ $t("Contacts") }}
            </router-link>
          </li>
          <li>
            <a href="/our-partners" class="link">
              {{ $t("Our partners") }}
            </a>
          </li>
          <li>
            <a href="https://www.natur.cuni.cz/biology" class="link">
              {{ $t("Faculty of science - biology") }}
            </a>
          </li>
          <li>
            <a href="https://cuni.cz/uken-1.html" class="link">
              {{ $t("Charles University") }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="copyright">
      Copyright (C) Botanická zahrada přírodovědecké fakulty Univerzity Karlovy
    </div>
    <cookie-law theme="roweb"></cookie-law>
  </div>
</template>

<script lang="js">
import FacebookIcon from '@images/social/036-facebook.svg';
import InstagramIcon from '@images/social/029-instagram.svg';
import {ROUTE_NAMES} from '@/routes';
import CookieLaw from 'vue-cookie-law'

export default {
    components: {
        CookieLaw,
        FacebookIcon,
        InstagramIcon
    },
  computed: {
    ROUTE_NAMES() {
      return ROUTE_NAMES;
    }
  }
}
</script>

<style lang="scss">
@import "./paeg-footer-unscoped";
</style>

<style lang="scss" scoped>
@import "./../styles/index";

.footer-body {
  padding: 1rem $page-side-margin-size 0 $page-side-margin-size;
  background-color: #e1e1e1;

  .links-column {
    display: flex;
    flex-direction: column;

    @include touch {
      justify-content: center;
    }
  }

  .link {
    color: $text;
    cursor: pointer;

    &:hover {
      @include link-underline(#e1e1e1, $text, $color-selection);
    }
  }

  .subscribe-column {
    display: flex;
    justify-content: center;
  }

  .subscribe-tile {
    display: flex;
    flex-direction: column;
    width: 20rem;

    @include touch() {
      width: 100%;
    }

    .subscribe-input {
      width: 20rem;

      @include touch() {
        width: 100%;
      }
    }

    .subscribe-button-wrapper {
      text-align: right;
    }
  }

  .social-tile {
    .social-icon {
      cursor: pointer;
      opacity: 0.9;
      transition-property: opacity, transform;
      transition-duration: 0.2s;

      &:hover {
        opacity: 1;
        transform: scale(1.05, 1.05);
      }
    }
  }
}

.copyright {
  margin-top: 2rem;
  text-align: center;
}
</style>
